<template>
  <div class="dashboard-page">
    <div class="simple-page">
      <div class="simple-page__title">
        <h1>Дашборд</h1>
      </div>

      <div class="simple-page__content" style="height: auto !important">
        <Loading overlay-color="rgba(255, 255, 255, 0.5)" v-if="isLoading" />
        <div class="f" style="gap: 1rem; flex-wrap: wrap">
          <TirPmDatepicker
            :input="{ label: 'Дата начала', isSmall: true }"
            v-model="req.FromDate"
            :type="DatepickerTypeEnum.DateTime"
            @update:model-value="onUpdate"
          />
          <TirPmDatepicker
            :type="DatepickerTypeEnum.DateTime"
            :input="{ label: 'Дата окончания', isSmall: true }"
            v-model="req.ToDate"
            @update:model-value="onUpdate"
          />
          <TirPmButton
            :variant="TirPmButtonVariantEnum.PrimaryState"
            :size="TirPmButtonSizeEnum.Regular"
            @click="onUpdate"
          >
            <template #leftSlot><ArrowPathIcon /></template>
            Обновить</TirPmButton
          >
        </div>
        <div class="content">
          <div class="f mt-10 mb-10" style="gap: 1rem; flex-wrap: wrap">
            <Plashka name="Активных задач сейчас">
              <template #status>
                <ScheduleStatus
                  :type-name="EnumJobStatus.Running"
                  :is-full-size="true"
                />
              </template>
              {{ resp?.JobsActiveCount }}
            </Plashka>
            <Plashka name="Успешных задач за период">
              <template #status>
                <ScheduleStatus
                  :type-name="EnumJobStatus.Success"
                  :is-full-size="true"
              /></template>
              {{ resp?.JobsExecutesSuccessCount }}
            </Plashka>
            <Plashka name="Задач с ошибками за период">
              <template #status>
                <ScheduleStatus
                  :type-name="EnumJobStatus.Failed"
                  :is-full-size="true"
              /></template>
              {{ resp?.JobsExecutesFailedCount }}
            </Plashka>
            <Plashka name="Статусы за период">
              <template #status></template>
              <DonutChart
                v-if="resp?.JobExecuteStatusStatistic"
                :data="resp.JobExecuteStatusStatistic"
              />
            </Plashka>
          </div>
          <div class="wrapper">
            <GanttChart
              v-if="timeLineResp?.Jobs"
              :startDate="req.FromDate"
              :endDate="req.ToDate"
              :tasks="timeLineResp.Jobs"
              @task-clicked="handleTaskClick"
            />
            <StatusChanges :items="statusChangesItems" />
          </div>
          <div
            class="simple-page__table mt-10"
            style="height: none; position: relative"
          >
            <div class="mb-5">Последние ошибки</div>
            <TirPmTable :columns="columnTableSetting" :isBordered="false">
              <template #topSlot></template>
              <template #tableHead>
                <TirPmTableTh :isLeftBorder="false" style="min-width: 100px">
                  Дата создания
                </TirPmTableTh>
                <TirPmTableTh isLeftBorder>Название задачи</TirPmTableTh>
                <TirPmTableTh isLeftBorder>Статус</TirPmTableTh>
                <TirPmTableTh isLeftBorder>Сообщение</TirPmTableTh>
              </template>
              <template #tableBody>
                <!-- UserList -->
                <TirPmTableTr
                  v-for="data of lastErrorItems"
                  :key="data.Id"
                  :columns="columnTableSetting"
                  @on-scroll="onScroll"
                >
                  <DashboardRow
                    :data="data"
                    @clickAction="onClickAction"
                    @clickDetail="onClickDetail"
                    @clickRemove="onClickRemove"
                  >
                  </DashboardRow>
                </TirPmTableTr>
              </template>
              <template #emptyDataSlot>
                <TirPmSystemMessage
                  v-if="!(items?.length > 0)"
                  style="width: 100%"
                >
                  <template #topDescImage> </template>
                  <template #mainTitleSlot>Нет данных</template>
                  <template #mainSubtitleSlot>
                    Поменяйте параметры фильтра или перезагрузите
                  </template>
                  <template #actionsSlot> </template>
                </TirPmSystemMessage>
              </template>
            </TirPmTable>
          </div>
        </div>
      </div>

      <!-- 
      <UcPropertyDrawer
        :title="drawerTitle"
        ref="$propertyDriver"
        @ok="onUpdate"
      >
        <template #content>
          <div>
            <div style="position: relative">
              <TirPmInput
                v-model="currentItem.Name"
                @keyup.enter="onUpdate"
                label="Название тега"
                :isWithHint="false"
                @update:model-value="updateParameterName"
                @enter="sendParameter"
                @focus="setIsFocus(true)"
                @blur="setIsFocus(false)"
              />
              <Transition name="task-parameters-input_animation">
                <TirPmColorPalette
                  style="position: absolute; top: 1rem; right: 1rem"
                  class="task-parameters-input_color"
                  :model-value="Color"
                  :position="PopoverPositionEnum.Bottom"
                  :colors="getPalette()"
                  @update:model-value="updateParameterColor"
                >
                  <template #icon="slot">
                    <div
                      class="task-parameters-input_color_icon pointer"
                      @mousedown.stop
                    >
                      <div
                        style="
                          width: 1.4rem;
                          height: 1.4rem;
                          border-radius: 0.5rem;
                        "
                        :style="{ background: slot.color }"
                      />
                    </div>
                  </template>
                </TirPmColorPalette>
              </Transition>
            </div>
          </div>
        </template>
      </UcPropertyDrawer> -->
      <!-- <DialogDelete
        title="Удалить тег?"
        text="Вы уверены что хотите удалить тег:"
        :text1="standName"
        ref="$dialogDelete"
        @ok="onRemoveStand"
      /> -->
    </div>
  </div>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";
import {
  ArrowRightIcon,
  PlusIcon,
  Cog8ToothIcon,
  ClockIcon,
  PuzzlePieceIcon,
  ArrowPathIcon,
} from "tir-style-system/icons/outline";
import { ArrowLeftIcon } from "tir-style-system/icons/solid";
import { useRoute, useRouter } from "vue-router";
import {
  DatepickerTypeEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDatepicker,
} from "tir-components";
import Plashka from "./components/plashka.vue";
import { ScheduleStatus } from "../_uc/schedule-status";
import EnumJobStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobStatus";
import GanttChart from "./components/gantt-chart.vue";
import StatusChanges from "./components/status-changes.vue";
import JobStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/JobStatusHistoryItem";
import EnumJobContainerStatus from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/database/enums/EnumJobContainerStatus";
import StatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/jobs/histories/status/StatusHistoryItem";
import ContainerStatusHistoryItem from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/containers/ContainerStatusHistoryItem";
import TirPmTable from "tir-pm-table/src/TirPmTable.vue";
import TirPmTableTh from "tir-pm-table/src/TirPmTableTh.vue";
import TirPmTableTr from "tir-pm-table/src/TirPmTableTr.vue";
import DashboardParametersRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/DashboardParametersRequest";
import DashboardParametersResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/DashboardParametersResponse";
import AdapterDashboardService from "./adapter/AdapterDashboardService";
import DonutChart from "./components/DonutChart.vue";
import JobsTimelineRequest from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsTimelineRequest";
import JobsTimelineResponse from "@/api/SchedulerAdmin/dataSource/api/scheduler/manager/serverless/i-services/models/dashboard/JobsTimelineResponse";
import PageRequest from "@/api/SchedulerAdmin/dataSource/api/pagination-helper/lib/PageRequest";
import DashboardRow from "./components/dashboard-row.vue";
import Loading from "../_uc/Loading.vue";
// Определение пропсов компонента
const props = defineProps({
  isCompact: { type: Boolean, value: true },
  msg: { type: String, default: "" },
});

// Определение эмиттеров событий компонента
const emits = defineEmits<{
  clickLogout: []; // Событие при клике на кнопку "Выход"
  "update:message": [string]; // Событие обновления сообщения
}>();
const resp = ref<DashboardParametersResponse>();
const req = ref<DashboardParametersRequest>();

const timeLineResp = ref<JobsTimelineResponse>();
const timeLineReq = ref<JobsTimelineRequest>();

const route = useRoute();
const adapter = new AdapterDashboardService();
const runTasks = ref([]);
const isLoading = ref(false);
req.value = new DashboardParametersRequest({
  FromDate: (() => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  })(),
  ToDate: new Date(new Date().setHours(23, 59, 59, 999)),
  ProjectId: Number(route.params.id),
});

const lastErrorPage = ref(new PageRequest({ Skip: 0, Take: 100 }));

onMounted(async () => {
  console.log("mounted");
  await onUpdate();
});
const ToDate = ref(new Date());
const FromDate = ref(new Date());

const onUpdate = async () => {
  isLoading.value = true;
  const x = await adapter.getDashboardParameters(req.value);
  resp.value = x.Value;

  timeLineReq.value = new JobsTimelineRequest({
    FromDate: req.value.FromDate,
    ToDate: req.value.ToDate,
    ProjectId: req.value.ProjectId,
  });
  const x1 = await adapter.getJobsTimelines(timeLineReq.value);
  timeLineResp.value = x1.Value;
  // emits("update:message", "value");
  const r = await adapter.getJobsLastErrors({
    FromDate: req.value.FromDate,
    ToDate: req.value.ToDate,
    ProjectId: req.value.ProjectId,
    Page: lastErrorPage.value,
  });
  isLoading.value = false;
  lastErrorItems.value = r.Value.Items;
};
const columnTableSetting = ref(["10rem", "20rem", "10rem", "1fr"]);
const router = useRouter();
const statusChangesItems = ref([]);
const lastErrorItems = ref([]);

const handleTaskClick = async (value: {
  jobId: string;
  jobExecuteId: string;
}) => {
  console.log("Task clicked with JobExecuteId:", value.jobExecuteId);
  if (!value.jobId || !value.jobExecuteId) {
    statusChangesItems.value = [];
    return;
  }
  const resp = await adapter.getJobStatusHistory({
    JobId: value.jobId,
    JobExecuteHistoryId: value.jobExecuteId,
    Page: { Skip: 0, Take: 100 },
  });
  statusChangesItems.value = resp.Value.Items;
  // Здесь можно добавить дополнительную логику, например, открыть детали задачи
};
const onScroll = (e) => {
  console.log(e);
};
const items = ref([]);
const onClickAction = (e) => {
  console.log(e);
};
const onClickDetail = (e) => {
  console.log(e);
};
const onClickRemove = (e) => {
  console.log(e);
};
</script>

<style lang="scss">
.dashboard-page {
  .pointer {
    cursor: pointer;
  }
  &__title {
    display: flex;
    align-items: center;
  }
  &__content {
    border: 0.063rem solid var(--neutral-05);
    border-radius: 0.5rem;
    background-color: var(--bg-base);
    padding: 1.5rem;
    display: flex;
  }
  .wrapper {
    border-radius: 0.5rem;
    border: 1px solid #ccc;
    padding: 0.7rem;
    background-color: var(--bg-secondary);
  }
  .simple-page__table {
    border-radius: 0.5rem;
    border: 1px solid #ccc;
    padding: 1rem;
    background-color: var(--bg-secondary);
    .table-container {
      background-color: var(--bg-base);
      .table-grid {
        .table-grid-td--left-border::before,
        .table-grid-th--left-border::before {
          // display: none;
          top: 0rem;
          bottom: 0rem;
          width: 0.05rem;
        }
        .table-grid-tr,
        .table-grid-header {
          padding: 0rem;
        }
        .table-grid-td,
        .table-grid-th {
          padding: 0.375rem;
        }
        .table-grid-body {
          overflow: auto;
          max-height: calc(100vh - 25rem);
          height: auto;
        }
      }
    }
  }
}
</style>
